import { IPriseJobsPreview } from 'pages/common/IPriseJobs';
import CandidateMatchScoresScreen from 'pages/iPriseV2/common/candidate-match-scores';
import Teams from 'pages/iPriseV2/common/teams';
import TeamDetail from 'pages/iPriseV2/common/teams/team-detail';
import ViewCandidate from 'pages/iPriseV2/common/view-candidate';
import ViewJobV2 from 'pages/iPriseV2/common/view-job';
import ViewMatchedCandidate from 'pages/iPriseV2/common/view-matched-candidate';
import Candidates from 'pages/iPriseV2/management/candidates';
import JobQueue from 'pages/iPriseV2/management/job-queue';
import Header from 'pages/iPriseV2/management/layout/Header';
import ManagementProfile from 'pages/iPriseV2/management/profile';
import Reports from 'pages/iPriseV2/management/reports';
import System from 'pages/iPriseV2/management/system';
import { ViewJob } from 'pages/sales/JobPosting/ViewJob';
import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';

const ManagementRoutes = () => {
  return (
    <Routes>
      <Route path="management" element={<Header />}>
        <Route index element={<Navigate to="teams" replace />} />
        <Route path="teams" element={<Teams />} />
        <Route path="team/:id" element={<TeamDetail />} />
        <Route path="job-queue" element={<JobQueue />} />
        <Route path="view-job/:id" element={<ViewJobV2 />} />
        <Route
          path={'job-post/view-job/iprise-job/:jobId'}
          element={<ViewJob />}
        />
        <Route
          path={'job-post/view-job/iprise-job/candidate/:jobId/:candidateId'}
          element={<IPriseJobsPreview visible={true} />}
        />
        <Route
          path="view-matched-candidate"
          element={<ViewMatchedCandidate />}
        />
        <Route
          path="view-matched-candidate-scores"
          element={<CandidateMatchScoresScreen />}
        />
        <Route path="view-candidate/:candidateId" element={<ViewCandidate />} />
        <Route path="candidates" element={<Candidates />} />
        <Route path="reports" element={<Reports />} />
        <Route path="system" element={<System />} />
        <Route path="profile" element={<ManagementProfile />} />
      </Route>
      {/* Redirect any unknown route to management/teams */}
      <Route path="*" element={<Navigate to="management/teams" replace />} />
    </Routes>
  );
};

export default ManagementRoutes;
